module.exports = __webpack_public_path__ + "static/img/page_PLAY02.32384f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series4/course-rm-02/page_PLAY02.png
// module id = k7Sh
// module chunks = 0